// components/MarkdownWithPlaceholders.tsx
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { PLACEHOLDER_COMPONENTS } from "../../../utils/format";
import styles from './ModalNotify.module.scss';

interface MarkdownWithPlaceholdersProps {
    message: string;
}

export const MarkdownWithPlaceholders: React.FC<MarkdownWithPlaceholdersProps> = ({ message }) => {
    const { processedMessage, componentsMap } = replacePlaceholdersWithMarkers(message);

    return (
        <ReactMarkdown
            components={{
                a: ({ node, href, children, ...props }) => (
                    <a href={href} className={styles.link} {...props}>
                        {children}
                    </a>
                ),
                p: ({ children }) => {
                    const processedChildren = replaceMarkersWithComponents(children, componentsMap);
                    return <p>{processedChildren}</p>;
                }
            }}
        >
            {processedMessage}
        </ReactMarkdown>
    );
};

const replacePlaceholdersWithMarkers = (message: string) => {
    const componentsMap: { [key: string]: React.ReactElement } = {};
    let markerCounter = 0;
    
    let processedMessage = message;
    
    Object.keys(PLACEHOLDER_COMPONENTS).forEach(placeholder => {
        while (processedMessage.includes(placeholder)) {
            const marker = `%%COMPONENT_${markerCounter}%%`;
            componentsMap[marker] = PLACEHOLDER_COMPONENTS[placeholder](`comp-${markerCounter}`);
            processedMessage = processedMessage.replace(placeholder, marker);
            markerCounter++;
        }
    });
    
    return { processedMessage, componentsMap };
};

const replaceMarkersWithComponents = (children: any, componentsMap: { [key: string]: React.ReactElement }): React.ReactNode => {
    if (typeof children === 'string') {
        // Создаем регулярное выражение для поиска всех маркеров
        const markerPattern = Object.keys(componentsMap).map(marker => 
            marker.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        ).join('|');
        
        const regex = new RegExp(`(${markerPattern})`, 'g');
        const parts = children.split(regex);
        
        if (parts.length === 1) {
            return children; // Нет маркеров
        }
        
        return parts.map((part, index) => {
            if (componentsMap[part]) {
                return React.cloneElement(componentsMap[part], { key: `marker-${index}` });
            }
            return part;
        });
    }
    
    if (Array.isArray(children)) {
        return children.map((child, index) => (
            <React.Fragment key={index}>
                {replaceMarkersWithComponents(child, componentsMap)}
            </React.Fragment>
        ));
    }
    
    return children;
};